var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_c('icon',{attrs:{"name":"exclamation-triangle"}}),_vm._v(" Preview Not Available ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }